import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import styles from './index.module.scss';
import { IconFrown, IconSmile } from '../../../Common/Icon';
import { useHelpful } from '../../../../hooks/api/article';

export interface QuestionarieProps {
  id: string | undefined;
}

export default function Questionarie({ id }: QuestionarieProps): React.ReactNode | null {
  const helpful = useHelpful(id);
  const [submitted, setSubmitted] = useState(false);
  const [visible, setVisible] = useState(true);

  const handleYesClick = () => {
    if (id) {
      helpful.fetch().then(() => {
        setSubmitted(true);
      });
    }
  };

  const handleNoClick = () => {
    setSubmitted(true);
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (submitted && !helpful.loading) {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [submitted]);

  if (!visible) return null;

  return (
    <div className={styles.questionarie}>
      <span>
        {submitted ? 'Thanks for sharing your thoughts.' : 'Did this article help?'}
      </span>
      {!submitted && (
        <div className={styles.btns}>
          <Button loading={helpful.loading} icon={<IconSmile />} className={styles.btn} onClick={handleYesClick}>
            Yes
          </Button>
          <Button icon={<IconFrown />} className={styles.btn} onClick={handleNoClick}>
            No
          </Button>
        </div>
      )}
    </div>
  );
}
